/* tslint:disable */
/* eslint-disable */
/**
 * CAST.AI API documentation
 * ### Feature maturity indicators (may appear on resources, operations and request/response fields)  - **(BETA)** - new or experimental features, subject to change  - **(Deprecated)** - outdated or replaced features (a reason and removal date will be provided in the description) 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CostreportV1beta1GetClusterNodeTemplatesReportResponse } from '../models';
// @ts-ignore
import type { CostreportV1beta1GetClusterNodesStorageReportResponse } from '../models';
// @ts-ignore
import type { CostreportV1beta1GetNodeLabelNamesResponse } from '../models';
// @ts-ignore
import type { CostreportV1beta1GetNodeLabelValuesResponse } from '../models';
// @ts-ignore
import type { CostreportV1beta1NodeLabelFilters } from '../models';
/**
 * NodeReportAPIApi - axios parameter creator
 * @export
 */
export const NodeReportAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Gets the node templates report for a cluster.
         * @param {string} clusterId ID of the cluster.
         * @param {boolean} [useListingPrices] Whether to use listing prices instead of actual prices for cost calculations.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeReportAPIGetClusterNodeTemplatesReport: async (clusterId: string, useListingPrices?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('nodeReportAPIGetClusterNodeTemplatesReport', 'clusterId', clusterId)
            const localVarPath = `/v1/cost-reports/clusters/{clusterId}/node-templates`
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (useListingPrices !== undefined) {
                localVarQueryParameter['useListingPrices'] = useListingPrices;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets ephemeral storage metrics per node for a cluster.
         * @param {string} clusterId ID of the cluster.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeReportAPIGetClusterNodesStorageReport: async (clusterId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('nodeReportAPIGetClusterNodesStorageReport', 'clusterId', clusterId)
            const localVarPath = `/v1/cost-reports/clusters/{clusterId}/nodes/storage`
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets the kubernetes label names applied to the node in the organization.
         * @param {string} startTime Filter items to include from specified time.
         * @param {string} endTime Filter items to include up to specified time.
         * @param {CostreportV1beta1NodeLabelFilters} labelFilters Filter items by more label specific fields.
         * @param {string} [pageLimit] 
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page. Empty value indicates to start from beginning of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeReportAPIGetNodeLabelNames: async (startTime: string, endTime: string, labelFilters: CostreportV1beta1NodeLabelFilters, pageLimit?: string, pageCursor?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startTime' is not null or undefined
            assertParamExists('nodeReportAPIGetNodeLabelNames', 'startTime', startTime)
            // verify required parameter 'endTime' is not null or undefined
            assertParamExists('nodeReportAPIGetNodeLabelNames', 'endTime', endTime)
            // verify required parameter 'labelFilters' is not null or undefined
            assertParamExists('nodeReportAPIGetNodeLabelNames', 'labelFilters', labelFilters)
            const localVarPath = `/v1/cost-reports/node-labels/names`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startTime !== undefined) {
                localVarQueryParameter['startTime'] = (startTime as any instanceof Date) ?
                    (startTime as any).toISOString() :
                    startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = (endTime as any instanceof Date) ?
                    (endTime as any).toISOString() :
                    endTime;
            }

            if (pageLimit !== undefined) {
                localVarQueryParameter['page.limit'] = pageLimit;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page.cursor'] = pageCursor;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(labelFilters, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets the kubernetes label values for the given label name.
         * @param {string} label Label name. Max length of 317 &#x3D; 253 (optional prefix) + 1 (slash) + 63 (name segment) according to https://kubernetes.io/docs/concepts/overview/working-with-objects/labels/#syntax-and-character-set
         * @param {string} startTime Filter items to include from specified time.
         * @param {string} endTime Filter items to include up to specified time.
         * @param {CostreportV1beta1NodeLabelFilters} labelFilters Filter items by more label specific fields.
         * @param {string} [pageLimit] 
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page. Empty value indicates to start from beginning of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeReportAPIGetNodeLabelValues: async (label: string, startTime: string, endTime: string, labelFilters: CostreportV1beta1NodeLabelFilters, pageLimit?: string, pageCursor?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'label' is not null or undefined
            assertParamExists('nodeReportAPIGetNodeLabelValues', 'label', label)
            // verify required parameter 'startTime' is not null or undefined
            assertParamExists('nodeReportAPIGetNodeLabelValues', 'startTime', startTime)
            // verify required parameter 'endTime' is not null or undefined
            assertParamExists('nodeReportAPIGetNodeLabelValues', 'endTime', endTime)
            // verify required parameter 'labelFilters' is not null or undefined
            assertParamExists('nodeReportAPIGetNodeLabelValues', 'labelFilters', labelFilters)
            const localVarPath = `/v1/cost-reports/node-labels/values`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (label !== undefined) {
                localVarQueryParameter['label'] = label;
            }

            if (startTime !== undefined) {
                localVarQueryParameter['startTime'] = (startTime as any instanceof Date) ?
                    (startTime as any).toISOString() :
                    startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = (endTime as any instanceof Date) ?
                    (endTime as any).toISOString() :
                    endTime;
            }

            if (pageLimit !== undefined) {
                localVarQueryParameter['page.limit'] = pageLimit;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page.cursor'] = pageCursor;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(labelFilters, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NodeReportAPIApi - functional programming interface
 * @export
 */
export const NodeReportAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NodeReportAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Gets the node templates report for a cluster.
         * @param {string} clusterId ID of the cluster.
         * @param {boolean} [useListingPrices] Whether to use listing prices instead of actual prices for cost calculations.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async nodeReportAPIGetClusterNodeTemplatesReport(clusterId: string, useListingPrices?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CostreportV1beta1GetClusterNodeTemplatesReportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.nodeReportAPIGetClusterNodeTemplatesReport(clusterId, useListingPrices, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NodeReportAPIApi.nodeReportAPIGetClusterNodeTemplatesReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Gets ephemeral storage metrics per node for a cluster.
         * @param {string} clusterId ID of the cluster.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async nodeReportAPIGetClusterNodesStorageReport(clusterId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CostreportV1beta1GetClusterNodesStorageReportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.nodeReportAPIGetClusterNodesStorageReport(clusterId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NodeReportAPIApi.nodeReportAPIGetClusterNodesStorageReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Gets the kubernetes label names applied to the node in the organization.
         * @param {string} startTime Filter items to include from specified time.
         * @param {string} endTime Filter items to include up to specified time.
         * @param {CostreportV1beta1NodeLabelFilters} labelFilters Filter items by more label specific fields.
         * @param {string} [pageLimit] 
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page. Empty value indicates to start from beginning of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async nodeReportAPIGetNodeLabelNames(startTime: string, endTime: string, labelFilters: CostreportV1beta1NodeLabelFilters, pageLimit?: string, pageCursor?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CostreportV1beta1GetNodeLabelNamesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.nodeReportAPIGetNodeLabelNames(startTime, endTime, labelFilters, pageLimit, pageCursor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NodeReportAPIApi.nodeReportAPIGetNodeLabelNames']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Gets the kubernetes label values for the given label name.
         * @param {string} label Label name. Max length of 317 &#x3D; 253 (optional prefix) + 1 (slash) + 63 (name segment) according to https://kubernetes.io/docs/concepts/overview/working-with-objects/labels/#syntax-and-character-set
         * @param {string} startTime Filter items to include from specified time.
         * @param {string} endTime Filter items to include up to specified time.
         * @param {CostreportV1beta1NodeLabelFilters} labelFilters Filter items by more label specific fields.
         * @param {string} [pageLimit] 
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page. Empty value indicates to start from beginning of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async nodeReportAPIGetNodeLabelValues(label: string, startTime: string, endTime: string, labelFilters: CostreportV1beta1NodeLabelFilters, pageLimit?: string, pageCursor?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CostreportV1beta1GetNodeLabelValuesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.nodeReportAPIGetNodeLabelValues(label, startTime, endTime, labelFilters, pageLimit, pageCursor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NodeReportAPIApi.nodeReportAPIGetNodeLabelValues']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NodeReportAPIApi - factory interface
 * @export
 */
export const NodeReportAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NodeReportAPIApiFp(configuration)
    return {
        /**
         * 
         * @summary Gets the node templates report for a cluster.
         * @param {NodeReportAPIApiNodeReportAPIGetClusterNodeTemplatesReportRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeReportAPIGetClusterNodeTemplatesReport(requestParameters: NodeReportAPIApiNodeReportAPIGetClusterNodeTemplatesReportRequest, options?: RawAxiosRequestConfig): AxiosPromise<CostreportV1beta1GetClusterNodeTemplatesReportResponse> {
            return localVarFp.nodeReportAPIGetClusterNodeTemplatesReport(requestParameters.clusterId, requestParameters.useListingPrices, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets ephemeral storage metrics per node for a cluster.
         * @param {NodeReportAPIApiNodeReportAPIGetClusterNodesStorageReportRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeReportAPIGetClusterNodesStorageReport(requestParameters: NodeReportAPIApiNodeReportAPIGetClusterNodesStorageReportRequest, options?: RawAxiosRequestConfig): AxiosPromise<CostreportV1beta1GetClusterNodesStorageReportResponse> {
            return localVarFp.nodeReportAPIGetClusterNodesStorageReport(requestParameters.clusterId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets the kubernetes label names applied to the node in the organization.
         * @param {NodeReportAPIApiNodeReportAPIGetNodeLabelNamesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeReportAPIGetNodeLabelNames(requestParameters: NodeReportAPIApiNodeReportAPIGetNodeLabelNamesRequest, options?: RawAxiosRequestConfig): AxiosPromise<CostreportV1beta1GetNodeLabelNamesResponse> {
            return localVarFp.nodeReportAPIGetNodeLabelNames(requestParameters.startTime, requestParameters.endTime, requestParameters.labelFilters, requestParameters.pageLimit, requestParameters.pageCursor, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets the kubernetes label values for the given label name.
         * @param {NodeReportAPIApiNodeReportAPIGetNodeLabelValuesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeReportAPIGetNodeLabelValues(requestParameters: NodeReportAPIApiNodeReportAPIGetNodeLabelValuesRequest, options?: RawAxiosRequestConfig): AxiosPromise<CostreportV1beta1GetNodeLabelValuesResponse> {
            return localVarFp.nodeReportAPIGetNodeLabelValues(requestParameters.label, requestParameters.startTime, requestParameters.endTime, requestParameters.labelFilters, requestParameters.pageLimit, requestParameters.pageCursor, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for nodeReportAPIGetClusterNodeTemplatesReport operation in NodeReportAPIApi.
 * @export
 * @interface NodeReportAPIApiNodeReportAPIGetClusterNodeTemplatesReportRequest
 */
export interface NodeReportAPIApiNodeReportAPIGetClusterNodeTemplatesReportRequest {
    /**
     * ID of the cluster.
     * @type {string}
     * @memberof NodeReportAPIApiNodeReportAPIGetClusterNodeTemplatesReport
     */
    readonly clusterId: string

    /**
     * Whether to use listing prices instead of actual prices for cost calculations.
     * @type {boolean}
     * @memberof NodeReportAPIApiNodeReportAPIGetClusterNodeTemplatesReport
     */
    readonly useListingPrices?: boolean
}

/**
 * Request parameters for nodeReportAPIGetClusterNodesStorageReport operation in NodeReportAPIApi.
 * @export
 * @interface NodeReportAPIApiNodeReportAPIGetClusterNodesStorageReportRequest
 */
export interface NodeReportAPIApiNodeReportAPIGetClusterNodesStorageReportRequest {
    /**
     * ID of the cluster.
     * @type {string}
     * @memberof NodeReportAPIApiNodeReportAPIGetClusterNodesStorageReport
     */
    readonly clusterId: string
}

/**
 * Request parameters for nodeReportAPIGetNodeLabelNames operation in NodeReportAPIApi.
 * @export
 * @interface NodeReportAPIApiNodeReportAPIGetNodeLabelNamesRequest
 */
export interface NodeReportAPIApiNodeReportAPIGetNodeLabelNamesRequest {
    /**
     * Filter items to include from specified time.
     * @type {string}
     * @memberof NodeReportAPIApiNodeReportAPIGetNodeLabelNames
     */
    readonly startTime: string

    /**
     * Filter items to include up to specified time.
     * @type {string}
     * @memberof NodeReportAPIApiNodeReportAPIGetNodeLabelNames
     */
    readonly endTime: string

    /**
     * Filter items by more label specific fields.
     * @type {CostreportV1beta1NodeLabelFilters}
     * @memberof NodeReportAPIApiNodeReportAPIGetNodeLabelNames
     */
    readonly labelFilters: CostreportV1beta1NodeLabelFilters

    /**
     * 
     * @type {string}
     * @memberof NodeReportAPIApiNodeReportAPIGetNodeLabelNames
     */
    readonly pageLimit?: string

    /**
     * Cursor that defines token indicating where to start the next page. Empty value indicates to start from beginning of the dataset.
     * @type {string}
     * @memberof NodeReportAPIApiNodeReportAPIGetNodeLabelNames
     */
    readonly pageCursor?: string
}

/**
 * Request parameters for nodeReportAPIGetNodeLabelValues operation in NodeReportAPIApi.
 * @export
 * @interface NodeReportAPIApiNodeReportAPIGetNodeLabelValuesRequest
 */
export interface NodeReportAPIApiNodeReportAPIGetNodeLabelValuesRequest {
    /**
     * Label name. Max length of 317 &#x3D; 253 (optional prefix) + 1 (slash) + 63 (name segment) according to https://kubernetes.io/docs/concepts/overview/working-with-objects/labels/#syntax-and-character-set
     * @type {string}
     * @memberof NodeReportAPIApiNodeReportAPIGetNodeLabelValues
     */
    readonly label: string

    /**
     * Filter items to include from specified time.
     * @type {string}
     * @memberof NodeReportAPIApiNodeReportAPIGetNodeLabelValues
     */
    readonly startTime: string

    /**
     * Filter items to include up to specified time.
     * @type {string}
     * @memberof NodeReportAPIApiNodeReportAPIGetNodeLabelValues
     */
    readonly endTime: string

    /**
     * Filter items by more label specific fields.
     * @type {CostreportV1beta1NodeLabelFilters}
     * @memberof NodeReportAPIApiNodeReportAPIGetNodeLabelValues
     */
    readonly labelFilters: CostreportV1beta1NodeLabelFilters

    /**
     * 
     * @type {string}
     * @memberof NodeReportAPIApiNodeReportAPIGetNodeLabelValues
     */
    readonly pageLimit?: string

    /**
     * Cursor that defines token indicating where to start the next page. Empty value indicates to start from beginning of the dataset.
     * @type {string}
     * @memberof NodeReportAPIApiNodeReportAPIGetNodeLabelValues
     */
    readonly pageCursor?: string
}

/**
 * NodeReportAPIApi - object-oriented interface
 * @export
 * @class NodeReportAPIApi
 * @extends {BaseAPI}
 */
export class NodeReportAPIApi extends BaseAPI {
    /**
     * 
     * @summary Gets the node templates report for a cluster.
     * @param {NodeReportAPIApiNodeReportAPIGetClusterNodeTemplatesReportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodeReportAPIApi
     */
    public nodeReportAPIGetClusterNodeTemplatesReport(requestParameters: NodeReportAPIApiNodeReportAPIGetClusterNodeTemplatesReportRequest, options?: RawAxiosRequestConfig) {
        return NodeReportAPIApiFp(this.configuration).nodeReportAPIGetClusterNodeTemplatesReport(requestParameters.clusterId, requestParameters.useListingPrices, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets ephemeral storage metrics per node for a cluster.
     * @param {NodeReportAPIApiNodeReportAPIGetClusterNodesStorageReportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodeReportAPIApi
     */
    public nodeReportAPIGetClusterNodesStorageReport(requestParameters: NodeReportAPIApiNodeReportAPIGetClusterNodesStorageReportRequest, options?: RawAxiosRequestConfig) {
        return NodeReportAPIApiFp(this.configuration).nodeReportAPIGetClusterNodesStorageReport(requestParameters.clusterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets the kubernetes label names applied to the node in the organization.
     * @param {NodeReportAPIApiNodeReportAPIGetNodeLabelNamesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodeReportAPIApi
     */
    public nodeReportAPIGetNodeLabelNames(requestParameters: NodeReportAPIApiNodeReportAPIGetNodeLabelNamesRequest, options?: RawAxiosRequestConfig) {
        return NodeReportAPIApiFp(this.configuration).nodeReportAPIGetNodeLabelNames(requestParameters.startTime, requestParameters.endTime, requestParameters.labelFilters, requestParameters.pageLimit, requestParameters.pageCursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets the kubernetes label values for the given label name.
     * @param {NodeReportAPIApiNodeReportAPIGetNodeLabelValuesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodeReportAPIApi
     */
    public nodeReportAPIGetNodeLabelValues(requestParameters: NodeReportAPIApiNodeReportAPIGetNodeLabelValuesRequest, options?: RawAxiosRequestConfig) {
        return NodeReportAPIApiFp(this.configuration).nodeReportAPIGetNodeLabelValues(requestParameters.label, requestParameters.startTime, requestParameters.endTime, requestParameters.labelFilters, requestParameters.pageLimit, requestParameters.pageCursor, options).then((request) => request(this.axios, this.basePath));
    }
}

